import React from 'react';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import type { BiEvent } from '@wix/da-bi/pkg/events';
import s from './ContentByUser.scss';

export interface Props {
  contentUrl: string;
  contentTitle: string;
  biData?: BiEvent;
}

const ContentByUser: React.FC<React.PropsWithChildren<Props>> = ({
  contentUrl,
  biData,
  contentTitle,
}) => {
  return (
    <BiLink className={s['root']} href={contentUrl} biData={biData}>
      {contentTitle}
    </BiLink>
  );
};
ContentByUser.displayName = 'ContentByUser';

export default ContentByUser;
